const API_URL = process.env.API_URL;
const API_BASE = process.env.REACT_APP_BACKEND_API_URL
const ORDER_BASE_URL = process.env.REACT_APP_ORDER_BACKEND_API_URL
//api routes
const API_ROUTES = {
  BASE_URL: process.env.REACT_APP_BACKEND_API_URL,
  AUTHENTICATION: {
    LOGIN_AUTH: "jobSeeker/login",
    SIGN_UP_AUTH: "jobSeeker/signUp",
    LOGOUT_AUTH: "jobSeeker/google/logout",
    GENERATE_OTP: 'jobSeeker/generateOtp',
    VERIFY_OTP: 'jobSeeker/verifyOtp',
    GOOGLE_LOGIN: 'jobSeeker/login/google',
    RESET_PASSWORD_APPLY: '/jobSeeker/sendPasswordToken',
    CHANGE_PASSWORD: 'jobSeeker/resetPassword'
  },
  JOBSEEKER: {
    UPDATE_USER: 'jobSeeker/',
    GET_JOBSEEKER: 'jobSeeker/',
    SEARCH_JOBS_JOBSEEKER: 'jobSeeker/searchJobs',
    EDUCATION: 'jobSeeker/education',
    EXPERIANCES: 'jobSeeker/experience',
    GET_JOBSEEKER_SKILLS: 'skills',
    SKILLS: 'skills',
    GLOBAL_SKILLS:'jobSeeker/skills',
    UPLOAD_CV: 'jobSeeker/uploadCv',
    GET_JOBS: 'job/search',
    APPLY_JOB: 'jobSeeker/job/apply',
    SAVE_JOBS: 'jobSeeker/saveJob',
    GET_SAVE_JOBS: 'jobSeeker/getSavedJob',
    GET_REFFRED_JOBS: 'jobSeeker/get-referred-jobs',
    SEND_REFERE_JOB: 'jobSeeker/job/refer',
    GET_RECOMMENDED_JOBS: '/jobSeeker/getRecommendedJobs',
    UNSAVE_JOB: 'jobSeeker/removeSaveJob',
    GET_PROFILE_COMPLETEION_PERCENTAGE: 'jobSeeker/profileCompletion',
    GET_INTERVIEW_DATES: 'jobseeker/get-interview-dates',
    SEND_INTERVIEW_DATES: 'jobseeker/shedule-meeting',
    UPLOAD_PROFILE: 'jobSeeker/uploadPicture',
    REMOVE_PROFILE: 'jobSeeker/deletePicture',
    REMOVE_CV: 'jobSeeker/deleteCv',
    APPLIED_JOBS: 'jobSeeker/appliedJobs',
    GET_COUNTRIES: 'jobSeeker/countries',
    UPDATE_OWN_SKILL: 'jobSeeker/updateOwnSkills',
    CREATE_TICKET: 'jobSeeker/createTicket',
    GET_TICKET_LIST: 'jobSeeker/getTicketList',
    GET_ALL_SUBSCRIPTIONS: 'jobSeeker/subscription',
    GET_LATEST_SUBSCRIPTION: 'jobSeeker/subscription/latest',
    DOWNLOAD_CV: 'jobSeeker/downloadCv',
    DELETE_CV: 'jobSeeker/deleteCv',
    GET_ALL_CV: 'jobSeeker/getAllCvUrls',
    REFFER_JOB: 'jobSeeker/referJob',
    ACCEPT_REFRREL: 'jobSeeker/acceptReferral',
    JOB_DETAILS: 'jobSeeker/jobDetails',
    REFFERED_BY_JOBS: 'jobSeeker/referredByJobs',
    REFFERED_TO_JOBS: 'jobSeeker/referredToJobs',
    SAVE_INTERVIEW_AVAILABILITY: 'jobSeeker/interviewSlots',
    NOTIFICATIONS: 'jobSeeker/notifications',
    GET_ALL_MEETINGS: 'jobSeeker/external/googleCalendar/meetings',
  },
  ORGANIZATION: {
    SIGN_UP_ORG: "org/orgSignUp",
    LOGIN_ORG: "org/orgLogin",
    GET_ORGANIZATION: 'org/',
    UPDATE_ORGANIZATION: 'org/',
    REMOVE_ORGANIZATION: 'org/',
    ADD_ORG_ROLES: 'org/addRoles',
    SCHEDULE_MEET: 'org/meet/create',
    GET_ORG_JOBS: 'org/jobs',
    UPDATE_STATUS_JOB: 'org/job',
    GET_JOB_BY_ID: 'org/jobs',
    GET_AUDITS: 'org/audit',
    SOCIAL_LINKS: 'org/social-links',
    ORG_EMAIL_VERIFY: 'org/orgEmailVerify',
    RESET_PASSWORD_APPLY_ORG: '/org/sendOrgPasswordToken',
    CHANGE_PASSWORD_ORG: 'org/resetPasswordOrg',
    SUBSCRIPTION: 'org/subscription',
    GETPERMISSIONS: 'org/getPermission',
    GET_BIND_USERS: 'org/bind',
    ADD_REPRESENTATAIVE_USER: 'org/representatives',
    REMOVE_BIND_USER: 'org/bind/remove',
    GET_ROLES: 'roles',
    GET_APLICATIONS: 'org/job/applications',
    GET_ALL_SUBSCRIPTIONS: 'org/subscription',
    GET_LATEST_SUBSCRIPTION: 'org/subscription/latest',
    RESET_PASSWORD_ORG: 'org/representative/resetPassword',
    GET_ALL_REPRESENTATIVES: 'org/representatives',
    GET_REPRESENTATIVE: 'org/representatives',
    UPDATE_REPRESENTATIVE: 'org/representatives',
    DELETE_REPRESENTATIVE: 'org/representatives',
    APPLICANT_PROFILE: 'org/job/applicantProfile',
    // JOB_APPLICATIONS:'org/job/applications',
    UPDATE_STATUS_OF_APPLICANTS: 'org/update-status',
    CONFIRM_INTERVIEW_SCHEDULE: 'org/selectInterviewSlot',
    GET_ALL_MEETINGS: 'org/calendar/meetings',
    UPDATE_INTERVIEW_RATING: 'org/interview/rating',
    CHECK_GOOGLE_INTEGRATION: 'org/external/googleOAuth',
    SCHEDULE_INTERVIEW_WITH_MEET: 'org/meet/create',
    ORG_RESEND_OTP: 'org/resendOtp',
    NOTIFICATIONS: 'org/notifications',
    BOOST_JOB: 'org/job/boost',
    UPDATE_JOB: 'org/job',
  },
  ROLES: {
    GET_ROLES: 'roles',
  },
  TOKENS: {
    TOKEN: 'tokens/'
  },
  TOKEN_HISTORY: {
    TOKEN_HISTORY: 'tokenshistory/'
  },
  SKILLS: {
    ALL_SKILLS: '/skills',
  },
  PRICES: {
    GET_ALL_PRICES: 'pricemodal/getAllPriceModel'
  },
  CMS:{
    REQUEST_DEMO:'cms/request-demo',
    CONTACT_API:'cms'
  },
  CHAT:{
    CONVERSATION:'conversation'
  },
  JOBS: {
    CREATE_JOBS: 'org/job',
    UPLOAD_JOB: 'org/uploadJob',
    GET_SHORTLISTED_CANDIDATE: 'org/jobs/shorlistedCandidate',
    SEND_DATES_TO_USER: 'org/sendDates',
    ACTIVATE_GOOGLE_MEET: 'org/external/googleMeet'
  }
};

const CONFIG = {
  TIMEOUT: 30000,
};

export { CONFIG, API_ROUTES, API_URL, API_BASE, ORDER_BASE_URL };
